import React, { useState } from "react";
import Dialog from "../Dialog/Dialog";


export default function EntityDeleteDialog({
  open,
  entityLabel,
  displayValue,
  onClose,
  services,
  idField,
  refParam,
  entity,
  onConfirm,
}) {

  const [isSaving, setIsSaving] = useState(false);
  // =========================
  // DELETE (REFRESH AFTER!)
  // =========================
const handleDelete = async () => {
    
    // Build payload
    let payload = { id: entity[idField] };

    // Add ticket_id if title is "Messages"
    if (entityLabel === "Message") {
      payload = { ...payload, ticket_id: refParam };
    }

    try {
      setIsSaving(true);
      await services.delete(payload, services.services_url_names.delete);
    } 
    catch (err) {
      console.error(err);
      return;
    }
    finally {
      setIsSaving(false);
    }

    // close dialog
    onClose?.();

    await onConfirm();
  };

  
  return (
    <Dialog open={open} onClose={onClose}>
        <h2>{`Delete ${entityLabel}`}</h2>
          <p>
            Are you sure you want to delete{" "}
            <b>{displayValue}</b>?
          </p>

          <div style={{ textAlign: "right", marginTop: "16px" }}>
            <button className="default-btn" onClick={onClose}>
              Cancel
            </button>
            <button
              className="label-btn"
              style={{ background: "#ff5252" }}
              onClick={handleDelete}
              disabled={isSaving}
            >
              {isSaving ? (
              <div className="spinner" style={{"--s-w":"16px", "--s-h":"16px"}}></div>
               ) : (
                "Delete"
              )}
            </button>
          </div>
      </Dialog>
  );
}
